import { request } from '../utils/request';

// 获取专场列表数据
export function getChannel(params) {
  return new Promise((resolve, reject) => {
    request('/v1/home/left-menu', { params, login: false })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 获取生活服务专场列表数据
export function getLifeService(channelId, params) {
  return new Promise((resolve, reject) => {
    request('/v2/channel/life/details/' + channelId, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 获取生活特权专场列表数据
export function getPrivilegeService(channelId, params) {
  return new Promise((resolve, reject) => {
    request('/v2/channel/privilege/details/' + channelId, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// banner点击
export function banner_click(params) {
  return new Promise((resolve, reject) => {
    request('/v1/channel/banner-click', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 获取商城配置
export function getConfig(params) {
  return new Promise((resolve, reject) => {
    request('/v1/config/index', { params, login: false })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 获取节日礼包列表
export function getFestival(params) {
  return new Promise((resolve, reject) => {
    request('/v1/channel/festival_channel', { ...params, login: false })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 定制入口列表（企业定制 / 节日礼包），支持分页：
// PC 无该封装，移植 mall_h5 lib/request.js 的 inletList；
// h5 的 custom/inlet/list 在 PC 侧要走带版本前缀的 /v1/custom/inlet/list
export function inletList(params) {
  return new Promise((resolve, reject) => {
    request('/v1/custom/inlet/list', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function helpArticle(params) {
  return new Promise((resolve, reject) => {
    request('/v1/config/help-article', { ...params, login: false })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function consentPrivacy(params) {
  return new Promise((resolve, reject) => {
    request('/v1/user/consent-privacy', { ...params, login: false })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 收货信息转city_id
 * @param {*} address_id
 * @returns
 */
export function addressChangeCity(address_id) {
  return new Promise((resolve, reject) => {
    request(`/v1/user-address/details/${address_id}`, { login: false })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function removeUrlParam(param) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        let params = new URLSearchParams(location.search);
        if (params.has(param)) params.delete(param);
        const newPath =
          location.pathname + '?' + params.toString() + location.hash;
        window.history.replaceState({}, document.title, newPath);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  });
}
